import { formatDateTime } from '../../../app/date';

export function buildImprovementSuggestionActionPrompt(item) {
  const formattedDate = formatDateTime(item.created_at) || item.created_at || '';
  const pageTitle = (item.page_title || '').trim() || '(sem título)';
  const pagePath = (item.page_path || '').trim() || '/';
  const workspace = (item.workspace_id || '').trim() || '(global)';
  const extraImage = item.has_extra_image ? 'sim' : 'não';
  const description = item.description || '';

  return `# Plano de ação — Sugestão de melhoria (Eagle)

Analise a sugestão abaixo registrada por um usuário do sistema Eagle e elabore um plano de ação para implementá-la. Em seguida, execute as alterações no repositório seguindo a arquitetura do projeto (backend Go hexagonal, frontend React/MUI, Docker).

## Metadados
- ID: ${item.id || ''}
- Data: ${formattedDate}
- Usuário: ${item.user_email || ''}
- Título da página: ${pageTitle}
- Caminho: ${pagePath}
- Workspace: ${workspace}
- Captura de tela: incluída na sugestão
- Imagem adicional: ${extraImage}

## Descrição completa
${description}

## O que fazer
1. Localize no código os arquivos e fluxos relacionados à página/módulo indicado.
2. Entenda o comportamento atual versus o desejado na descrição.
3. Produza um plano conciso (arquivos, riscos, validação).
4. Implemente a melhoria com diff mínimo e alinhado aos padrões Eagle.
5. Valide: \`docker exec eagle-backend go build\`, \`docker exec eagle-frontend yarn build\`.`;
}
